import React, { ReactNode } from 'react';
import { ButtonBar as ButtonBarStandard } from '@emorg-prd/standard-react';
import './ButtonBar.css';

interface ButtonBarProps extends React.ComponentProps<typeof ButtonBarStandard> {
	separator?: boolean;
	className?: string;
}

export interface ButtonBarItemProps extends React.HTMLAttributes<HTMLDivElement> {
	/** children of the container */
	children?: React.ReactNode;
	/** Additional css classes to append to the outer element */
	className?: string;
	separator?: boolean;
}

const ButtonBarItemWrapper: React.FC<ButtonBarItemProps> = ({ children, className, separator, ...props }) => {
	return (
		<div className={className + ` ${separator && 'separator'}`} {...props}>
			{children}
		</div>
	);
};

const ButtonBar: React.FC<ButtonBarProps> & { Item: typeof ButtonBarItemWrapper } = (props) => {
	return (
		<ButtonBarStandard optionalClass={props.className} {...props}>
			<div className={props.className}>{props.children}</div>
		</ButtonBarStandard>
	);
};

// Add ButtonBar.Item as static property
ButtonBar.Item = ButtonBarItemWrapper;

export { ButtonBar };
